export enum PassEventValidityRule {
  IncludedEvents = 'IncludedEvents',
  ExcludedEvents = 'ExcludedEvents',
}
